import React from 'react';

import { InfoText } from './Components/ContractText';

interface Props {
  offerPrice?: number;
}

const PurchasePrice = ({ offerPrice }: Props) => {
  const formatCurrency = (amount?: number) => {
    if (!amount) return 'N/A';
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  };

  return (
    <div className="mb-6">
      <h2
        className="text-lg font-bold mb-4"
        style={{ fontSize: '14pt', fontWeight: 'bold' }}
      >
        PURCHASE PRICE
      </h2>
      <div className="space-y-2">
        <p>
          The Purchase Price for the Property is {formatCurrency(offerPrice)}{' '}
          (hereinafter referred to as the "Purchase Price").
        </p>
      </div>
    </div>
  );
};

export default PurchasePrice;
